<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="purple">
                        <v-toolbar-title class="my-0 py-0">Registro de Capacitación (EI 089)</v-toolbar-title>
                        <v-spacer></v-spacer>
                        Código: {{ codgral }}
                    </v-toolbar>
                </v-card>
                <v-card color="purple lighten-4">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="4" md="1">
                                <v-text-field dense color="purple" label="Año:" outlined
                                    v-model="periodo"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card color="blue lighten-5" tile>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="8">
                                <!-- <v-card-actions> -->
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea dense rows="4" color="purple" auto-grow outlined v-model="tema"
                                            label="Tema desarrollado"></v-textarea>

                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea dense rows="4" color="purple" auto-grow outlined v-model="objetivo"
                                            label="Objetivo"></v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="8">
                                        <v-text-field dense v-model="capacitador" label="Capacitador"
                                            outlined></v-text-field>
                                    </v-col>
                                </v-row>
                                <!-- </v-card-actions> -->
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                                <!-- <h6><b> Tipo de Evaluación </b></h6>
                            <hr> -->
                                <div class="d-flex" style="max-width:600px">
                                    <h6><b> Tipo de Evaluación: </b></h6>
                                </div>
                                <div class="d-flex" style="max-width:600px">
                                    <v-checkbox v-model="tipoaulica" value="ON" label="Áulica"></v-checkbox>
                                    <v-checkbox v-model="tipodesemp" value="ON" label="Desempeño"></v-checkbox>
                                    <v-checkbox v-model="tipootro" value="ON" label="Otros  "></v-checkbox>
                                </div>
                                <div class="d-flex" style="max-width:600px">
                                    <v-text-field dense label="Especificar:" outlined v-model="evalotro"></v-text-field>
                                </div>
                                <div class="d-flex" style="max-width:600px">
                                    <h6><b> Lugar de Capacitación: </b></h6>
                                </div>
                                <div class="d-flex" style="max-width:600px">
                                    <v-radio-group v-model="lugar" row dense>
                                        <v-radio label="Planta / Oficina" value="PO"></v-radio>
                                        <v-radio label="Obras" value="OB"></v-radio>
                                        <v-radio label="Sucursal Bs As" value="SU"></v-radio>
                                        <v-radio label="Otros" value="OT"></v-radio>
                                    </v-radio-group>
                                </div>
                                <div class="d-flex" style="max-width:600px">
                                    <v-text-field dense label="Especificar:" outlined
                                        v-model="lugarotro"></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card color="purple lighten-4" tile>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="purple" label="Fecha:" outlined
                                    v-model="fecha"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="purple" label="Horas impartidas:" outlined
                                    v-model="horas"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="purple" label="Desde:" outlined
                                    v-model="desde"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="purple" label="Hasta:" outlined
                                    v-model="hasta"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field color="purple" dense label="Objetivo N°:" outlined v-model="numobj"
                                    hint="Separar con guión" persistent-hint></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card color="purple lighten-3" tile>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="3" md="3">
                                <v-select color="purple" dense v-model="legajo" :items="nomlegajo"
                                    label="Apellido y nombre" item-text="nombre" item-value="leg"
                                    return-object></v-select>
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <v-text-field color="purple" dense label="Especificar otro:" outlined
                                    v-model="particotro"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <v-text-field color="purple" dense label="DNI:" outlined
                                    v-model="particdni"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <v-btn color="purple" @click="agregar">
                                    Agregar Participante
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-data-table :headers="headers" :items="participantes" :items-per-page="100"
                                    hide-default-footer class="elevation-1">
                                    <template v-slot:top>
                                        <v-toolbar flat>

                                            <v-dialog v-model="dialogDelete" max-width="500px">
                                                <v-card>
                                                    <v-card-title class="headline">Está seguro que desea
                                                        borrar?</v-card-title>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="blue darken-1" text
                                                            @click="closeDelete">Cancel</v-btn>
                                                        <v-btn color="blue darken-1" text
                                                            @click="deleteItemConfirm">OK</v-btn>
                                                        <v-spacer></v-spacer>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-toolbar>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small color="red" @click="deleteItem(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="6">
                                <v-select color="purple" dense v-model="curso" :items="cursos" label="Curso"
                                    item-text="descr" item-value="codgral" return-object></v-select>
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <v-btn color="purple" @click="agregarcurso">
                                    Agregar Curso
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-data-table :headers="headersC" :items="listadocurso" :items-per-page="100"
                                    hide-default-footer class="elevation-1">
                                    <template v-slot:top>
                                        <v-toolbar flat>

                                            <v-dialog v-model="dialogDeleteC" max-width="500px">
                                                <v-card>
                                                    <v-card-title class="headline">Está seguro que desea
                                                        borrar?</v-card-title>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="blue darken-1" text
                                                            @click="closeDeleteC">Cancel</v-btn>
                                                        <v-btn color="blue darken-1" text
                                                            @click="deleteItemConfirmC">OK</v-btn>
                                                        <v-spacer></v-spacer>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-toolbar>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small color="red" @click="deleteItemC(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card color="purple" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>
</template>

<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}

.v-label {
    margin: 0 !important;
}

.v-input--selection-controls__input {
    label {
        margin: 0 !important;
    }
}
</style>
<style scoped>
.font-class-name {
    font-size: 14px;
}

.educacion {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
}

.educacion__niveles {
    border: solid 1px;
    list-style: none;
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        usuario: "",
        valid: false,
        lazy: false,
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        fecha: "",
        legajo: "",
        nomlegajo: [],
        particotro: "",
        particdni: "",
        participantes: [],
        headers: [
            { text: "Nombre", value: "nombre", sortable: false },
            { text: "Legajo", value: "legajo", sortable: false },
            { text: "DNI", value: "dni", sortable: false },
            { text: "Borrar", value: "actions", sortable: false },
        ],
        headersC: [
            { text: "Código", value: "curso", sortable: false },
            { text: "Curso", value: "descr", sortable: false },
            { text: "Borrar", value: "actions", sortable: false },
        ],
        periodo: moment().year(),
        resp: "",
        codgral: "",
        tema: "",
        objetivo: "",
        capacitador: "",
        horas: "",
        numobj: "",
        tipoaulica: "",
        tipodesemp: "",
        tipootro: "",
        evalotro: "",
        desde: "",
        hasta: "",
        lugar: "",
        lugarotro: "",
        nombre: "",
        dni: "",
        leg: "",
        cursos: [],
        curso: "",
        listadocurso: [],
        deshabilitar: false,
        editedIndex: -1,
        dialogDelete: false,
        editedIndexC: -1,
        dialogDeleteC: false,
        datospartic: [],
        datoscurso: [],
    }),
    computed: {

        show: {
            get() {
                this.cargarLegajo();
                this.cargarCurso();
                this.cargarCodgral();
            },

            set(value) {
                if (!value) {
                    this.vaciarListado();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        cargarLegajo() {
            let self = this;
            axios
                .get("/Icssa/CargarLegajo?")
                .then((response) => {
                    self.nomlegajo = response.data;
                })
                .catch((error) => {
                    self.nomlegajo = [];
                    console.log(error);
                });
        },

        cargarCurso() {
            let self = this;
            axios
                .get("/RRHH/CargarCursos")
                .then((response) => {
                    self.cursos = response.data;
                })
                .catch((error) => {
                    self.cursos = [];
                    console.log(error);
                });
        },

        cargarCodgral() {
            let self = this;
            axios
                .get("/RRHH/Cargarultimoregistro")
                .then((response) => {
                    self.codgral = response.data;
                })
                .catch((error) => {
                    self.codgral = "";
                    console.log(error);
                });
        },

        agregar() {
            if (this.particotro == "" || this.particotro == null) {
                this.nombre = this.legajo.nombre;
                this.leg = this.legajo.leg;
                this.dni = this.legajo.dni;
            }
            else {
                this.nombre = this.particotro;
                this.leg = "";
                this.dni = this.particdni;
            }
            this.participantes.push({
                nombre: this.nombre,
                legajo: this.leg,
                dni: this.dni
            })
            this.borrarparticipantes();
        },

        agregarcurso() {
            this.listadocurso.push({
                curso: this.curso.codgral,
                descr: this.curso.descr.substring(7),
            })
        },

        borrarparticipantes() {
            this.particdni = "";
            this.particotro = "";
        },

        deleteItem(item) {
            this.editedIndex = this.participantes.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },

        deleteItemC(item) {
            this.editedIndexC = this.cursos.indexOf(item);
            this.editedItemC = Object.assign({}, item);
            this.dialogDeleteC = true;
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeDeleteC() {
            this.dialogDeleteC = false;
            this.$nextTick(() => {
                this.editedItemC = Object.assign({}, this.defaultItemC);
                this.editedIndexC = -1;
            });
        },
        deleteItemConfirm() {
            this.participantes.splice(this.editedIndex, 1);
            this.closeDelete();
        },
        deleteItemConfirmC() {
            this.listadocurso.splice(this.editedIndexC, 1);
            this.closeDeleteC();
        },

        guardar() {
            if (
                (!this.tipoaulica && !this.tipodesemp && !this.tipootro) ||
                !this.periodo ||
                !this.tema ||
                !this.objetivo ||
                !this.capacitador ||
                !this.lugar ||
                !this.fecha ||
                !this.horas ||
                this.participantes.length === 0
            ) {
                this.showAlert({
                    icon: "error",
                    title: "Debe completar todos los campos",
                    vm: this,
                });
                return; // Cancelar guardado
            }
            this.$swal({
                title: "Guardar Registro",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                var i;
                if (result.value) {
                    this.deshabilitar = true;
                    this.participantes.forEach((element) => {
                        if (element.nombre != "" && element.nombre != null) {
                            this.datospartic.push({
                                nombre: element.nombre,
                                legajo: element.legajo,
                                dni: element.dni,
                            })
                        }
                    })
                    this.listadocurso.forEach((element) => {
                        if (element.curso != "" && element.curso != null) {
                            this.datoscurso.push({
                                curso: element.curso,
                            })
                        }
                    })
                    var datos = {
                        fecha: this.fecha,
                        periodo: this.periodo,
                        tema: this.tema,
                        objetivo: this.objetivo,
                        tipoaulica: this.tipoaulica,
                        tipodesemp: this.tipodesemp,
                        tipootro: this.tipootro,
                        evalotro: this.evalotro,
                        lugar: this.lugar,
                        lugarotro: this.lugarotro,
                        desde: this.desde,
                        hasta: this.hasta,
                        horas: this.horas,
                        capacitador: this.capacitador,
                        numobj: this.numobj,
                        cursos: this.datoscurso,
                        participantes: this.datospartic,
                    };

                    let self = this;
                    //  console.log("DATOS " + this.bienesalquiler[0].codgral)
                    axios
                        .post("/RRHH/GuardarRegistro", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();
                            self.vaciarModels();
                            self.showAlert({
                                icon: "success",
                                title: "Registro guardado con éxito",
                                vm: self,
                            });
                            self.$emit("close");
                        })
                        .catch({});

                } else {
                }
            });
        },


        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },

        vaciarModels() {
            this.fecha = "";
            this.periodo = "";
            this.tema = "";
            this.objetivo = "";
            this.tipoaulica = "";
            this.tipodesemp = "";
            this.tipootro = "";
            this.evalotro = "";
            this.lugar = "";
            this.lugarotro = "";
            this.desde = "";
            this.hasta = "";
            this.horas = "";
            this.capacitador = "";
            this.numobj = "";
            this.datoscurso = [];
            this.datospartic = [];
            this.$router.push({ name: "MainRRHH" });
        },
    },
};
</script>
